import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_BREAKPOINT_XS, SYS_BREAKPOINT_2_XL } from '../../../tokens/sizing.generated.js';
import styled from 'styled-components';
import { systemSpaceRelative } from './tokens/index.js';
const breakpointObject = {
    xs: SYS_BREAKPOINT_XS,
    sm: SYS_BREAKPOINT_SM,
    md: SYS_BREAKPOINT_MD,
    lg: SYS_BREAKPOINT_LG,
    xl: SYS_BREAKPOINT_XL,
    xxl: SYS_BREAKPOINT_2_XL
};
const generateCSS = (varsPerBreakpoint, breakpoints) => {
    let css = '';
    const prevValues = {};
    for (const [breakpoint, vars] of Object.entries(varsPerBreakpoint)) {
        let breakpointCss = '';
        vars.forEach((varObj) => {
            const [key, value] = Object.entries(varObj)[0] ?? [];
            if (value && key && (!prevValues[key] || prevValues[key] !== value)) {
                breakpointCss += `--spacing-relative-${key}: ${value};\n`;
                prevValues[key] = value;
            }
        });
        if (breakpoint === 'xs') {
            css += breakpointCss;
        }
        else if (breakpointCss) {
            css += `\n@media (min-width: ${breakpoints[breakpoint]}) {\n${breakpointCss}}\n`;
        }
    }
    return css;
};
export const ScopedVariables = styled.div `
  /*
  ** display: contents;
  ** These elements don't produce a specific box by themselves. 
  ** They are replaced by their pseudo-box and their child boxes.
  ** https://developer.mozilla.org/en-US/docs/Web/CSS/display#contents
  **
  */
  display: contents;
  ${generateCSS(systemSpaceRelative, breakpointObject)}
`;
//# sourceMappingURL=scoped-variables.styles.js.map